import { ElementProps } from '@/components/sections/builder/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';

export default function ElementContent({ element, data, preview, theme }: ElementProps) {
  const childs = element.childs || [];

  return (
    <>
      <section className='theme_cart_page_bg'>
        <div className='theme_layout_page_width mx-auto my-6 px-6 duration-100'>
          <div className='grid-cols-1 md:grid'>
            <div className='flex flex-col items-end text-right'>
              {childs.map((child) => (
                <WrapperChild
                  child={{
                    ...child,
                    parentData: data,
                    theme,
                  }}
                  key={child.id}
                  parentType={element.type}
                  preview={preview}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
